// extracted by mini-css-extract-plugin
export default {"FAQItem":"item_FAQItem__Xv6XQ","accordion":"item_accordion__ZMUKX","header":"item_header__OZaJt","body":"item_body__KF-oU","open":"item_open__ya8Ao"};